import { Component, OnInit } from '@angular/core';
import { Pagination } from '../../core/dto/pagination';
import { UserService } from '../../core/services/user.service';
import { PageSize } from '../../core/dto/page.size';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { Router } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { SETTINGS } from '../../core/config/common.settings';
import { RolesService } from '../../core/services/roles.service';
import * as _ from 'lodash';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
})
export class UsersComponent implements OnInit {
  breadcrumbs = [
    {
      title: 'Users',
      icon: 'user',
    },
  ];
  filterStatus: any;
  searchText: any;
  filterRole: any;
  isDeleting = false;
  usersData: any[] = [];
  pageSize = new PageSize();
  sortField: any;
  sortOrder: any = -1;
  department: any = '';
  rolesOptions: any[] = [];
  moreDep: number[] = [];

  skeletonTableColumns: any[] = [
    'Staff No',
    'User Name',
    'Role',
    'Mobile',
    'Email',
    'Department',
    'Status',
    'Last Login Date',
    'Created Date',
    'Actions',
  ];
  loading = false;

  constructor(
    private userService: UserService,
    private router: Router,
    private notificationService: NzNotificationService,
    private rolesService: RolesService,
    private message: NzMessageService,
  ) {}

  ngOnInit() {
    this.userService.loggedInUserSelectedDepartment.subscribe((res) => {
      this.department = res as string;
      this.getPagedUsers();
    });
    this.getRoleOptions();
  }

  onTableParamsChange(params: NzTableQueryParams): void {
    this.pageSize.pageSize = params.pageSize;
    this.pageSize.pageIndex = params.pageIndex;
    this.getPagedUsers();
  }

  getRoleOptions(): void {
    this.rolesService.getRolesForOptions().then((res) => {
      this.rolesOptions = res as any[];
    });
  }

  getPagedUsers(): void {
    this.loading = true;
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      filters: {
        department: this.department,
        role: this.filterRole,
        searchText: this.searchText,
        status: this.filterStatus,
      },
    });
    this.userService.getPagedUsers(payload).then((res: any) => {
      this.loading = false;
      this.usersData = res[0].data;
      this.pageSize.length = res[0].metadata[0]?.total;
      this.moreDep = [];
    });
  }

  goto(id?: any): void {
    if (id) {
      this.router.navigate([`/admin/users/roles/add-edit/${id}`]);
    } else {
      this.router.navigate(['/admin/users/roles/add-edit']);
    }
  }

  async softDeleteConfirm(id: any): Promise<void> {
    this.isDeleting = true;
    try {
      await this.userService.softDeleteUser(id);
      this.isDeleting = false;
      this.message.success('User has been deleted!');
      this.getPagedUsers();
    } catch (e) {
      this.isDeleting = false;
    }
  }

  resetPwd(userId: any): void {
    this.userService.resetUserPassword(userId).then((res: any) => {
      if (res.done) {
        this.message.success(res.message);
      }
    });
  }

  sort(): void {
    this.sortOrder = this.sortOrder === 1 ? -1 : 1;
    this.getPagedUsers();
  }

  search(): void {
    // console.log('role', this.filterRole);
    // console.log('text', this.searchText);
    // console.log('status', this.filterStatus);
    this.getPagedUsers();
  }

  resetSearch(): void {
    this.searchText = null;
    this.filterStatus = null;
    this.filterRole = null;
    this.getPagedUsers();
  }

  changeStatus(id: any, status: boolean): void {
    this.userService.updateUser({ _id: id, active: !status }).then((res) => {
      this.message.success(
        status ? 'User has been deactivated!' : 'User has been activated!',
      );
      this.getPagedUsers();
    });
  }

  hasAccessToPerformAction(): boolean {
    return (
      _.includes(
        localStorage.getItem(SETTINGS.USER_PERMISSIONS),
        'USER_UPDATE',
      ) ||
      _.includes(
        localStorage.getItem(SETTINGS.USER_PERMISSIONS),
        'USER_DELETE',
      ) ||
      _.includes(
        localStorage.getItem(SETTINGS.USER_PERMISSIONS),
        'USER_RESET_PASSWORD',
      )
    );
  }

  checkPermissionsWithUserActiveStatus(data: any, permission: string): boolean {
    return (
      _.includes(localStorage.getItem(SETTINGS.USER_PERMISSIONS), permission) &&
      data.active
    );
  }
  moreDepCollapse(rowNum: number, type: string) {
    if (type === 'more') {
      this.moreDep.push(rowNum);
    } else if (type === 'hide_more') {
      this.moreDep.forEach((val, i) => {
        if (val === rowNum) {
          this.moreDep.splice(i, 1);
        }
      });
    }
  }
  haveRowNumCheck(rowNum: number) {
    let val = false;
    if (this.moreDep.length === 0) {
      return val;
    }
    this.moreDep.forEach((dp: number) => {
      if (dp === rowNum) {
        val = true;
      }
    });
    return val;
  }
}
